import { menu } from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage-revamp/constant';
import { get } from 'lodash';

export default (changeValues: any, { pcForm, tabletForm, mobileForm }) => {
  if (!!get(changeValues, [menu])) {
    tabletForm.setFieldsValue(changeValues);
    mobileForm.setFieldsValue(changeValues);
  }
};
